import './style.scss';

var $ = require("jquery")
var moment = require('moment');
import {
    Calendar
} from '@fullcalendar/core';

require('popper.js')
var bootstrap = require('bootstrap');

import bootstrapPlugin from '@fullcalendar/bootstrap';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import resourceTimeGridPlugin from '@fullcalendar/resource-timegrid';
import deLocale from '@fullcalendar/core/locales/de';
import interactionPlugin from '@fullcalendar/interaction';

const eventUrl = "./get_belegung.php"

var colors = [
    "#007bff",
    "#6610f2",
    "#6f42c1",
    "#e83e8c",
    "#dc3545",
    "#fd7e14",
    "#ffc107",
    "#28a745",
    "#20c997",
    "#17a2b8"
]

Date.prototype.addDays = function (days) {
    var date = new Date(this.valueOf());
    date.setDate(date.getDate() + days);
    return date;
}


function parseResource(ss) {
    let resource = {
        id: ss.id,
        title: ss.ss_name,
    }

    return resource
}

function isNewRes(resources, newResource) {
    resources.forEach(resource => {
        if (resource.id == newResource.id) {
            return false
        }
    });

    return true
}

function parseJson(data) {
    var sportstätten = data.data.sportstaette
    var events = []
    var resources = []

    sportstätten.forEach(ss => {
        let resource = parseResource(ss)

        if (isNewRes(resources, resource) && typeof resource.id === "string" && resource.id != "") {
            resources.push(resource)
        }

        if(ss.wochentag == "7")  ss.wochentag = "0";

        var dates = getSerial(ss.wochentag, parseInt(ss.timestamp_von) * 1000, parseInt(ss.timestamp_bis) * 1000)
        console.log(dates);
        dates.forEach(date => {
            let strDate = date.getFullYear() + "/" + (date.getMonth() + 1) + "/" + date.getDate()

            let start = new Date(strDate + " " + ss.von)
            let end = new Date(strDate + " " + ss.bis)

            let event = {
                title: "belegt",
                start: start,
                end: end,
                resourceId: ss.id,
                extendedProps: {
                    sportstätte: ss.id
                }
            }

            events.push(event)
        });
    });

    events.sort((a, b) => a.start - b.start)

    var ssColors = []
    var lastUsedColor

    events.forEach(event => {

        ssColors.forEach(ssColor => {
            if (ssColor.id == event.extendedProps.sportstätte) {
                event.backgroundColor = ssColor.color
                event.borderColor = ssColor.color
            }
        });

        if (typeof event.backgroundColor === "undefined") {
            let color
            if (lastUsedColor === undefined || lastUsedColor == colors.length + 1) {
                color = colors[0]
                lastUsedColor = 0
            } else {
                lastUsedColor++
                color = colors[lastUsedColor]
            }

            event.backgroundColor = color
            event.borderColor = color

            let ssColor = {
                color: event.backgroundColor,
                id: event.extendedProps.sportstätte
            }

            ssColors.push(ssColor)
        }
    })

    const currEvents = events

    currEvents.forEach(event => {
        const hour = 60
        const buffer = 30
        const blockingStart = subMinutes(event.start, hour)
        const blockingEnd = addMinutes(event.end, buffer)

        let bEvent = {
            start: blockingStart,
            end: blockingEnd,
            resourceId: event.resourceId,
            rendering: 'background'
        }

        events.push(bEvent)
    })


    return [events, resources]
}


function getSerial(weekday, from, to) {
    var dates = []
    const timestampAnfang = 1577836800 * 1000
    const timestampEnde = 1609459199 * 1000

    if (typeof weekday != "string" || weekday == "" || (to < timestampAnfang && to != 0)) {
        console.log(dates)
        return dates
    }

    if (from < timestampAnfang || from == 0) {
        from = timestampAnfang
    }

    if (to > timestampEnde || to == 0) {
        to = timestampEnde
    }

    const day = 24 * 3600 * 1000


    var counter = 0

    for (let i = from; i < to; i += day) {
        const dateI = new Date(i)
        console.log("included: " + weekday)
        if (weekday.includes(dateI.getDay())) {

            dates.push(dateI)
        }

        counter++
    }

    return dates
}


function calcRatio() {
    var width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
    var height = (window.innerHeight > 0) ? window.innerHeight : screen.height;
    var ratio = width / height
    if (ratio > 1.35) ratio = 1.35
    ratio += 0.07

    return ratio
}


$.getJSON(eventUrl, function (data) {
    var result = parseJson(data)

    var events = result[0]
    var resources = result[1]

    var calendarEl = document.getElementById('calendar');

    var calendar = new Calendar(calendarEl, {
        allDaySlot: false,
        timeZone: 'local',
        locale: deLocale,
        plugins: [dayGridPlugin, timeGridPlugin, bootstrapPlugin, resourceTimeGridPlugin, interactionPlugin],
        defaultView: 'dayGridMonth',
        schedulerLicenseKey: 'GPL-My-Project-Is-Open-Source',
        header: {
            left: 'prev,next',
            center: 'title',
            right: 'dayGridMonth, timeGridWeek, resourceTimeGridDay',
        },
        themeSystem: 'bootstrap',
        businessHours: [{
                daysOfWeek: [1, 2, 3, 4, 5],
                startTime: '13:00',
                endTime: '21:00'
            },
            {
                daysOfWeek: [6, 0], // 0 is sunday
                startTime: '10:00',
                endTime: '21:00'
            }
        ],
        eventRender: function (info) {

            if (info.event.rendering != "background") {
                new bootstrap.Tooltip(info.el, {
                    title: 'belegt',
                    placement: 'top',
                    trigger: 'hover',
                    container: 'body'
                });
            }

        },
        eventClick: function (info) {
            $(info.el).tooltip('dispose')
            calendar.changeView('resourceTimeGridDay', info.event.start);
        },
        dateClick: function (info) {
            if (info.resource == undefined) {
                calendar.changeView('resourceTimeGridDay', info.date);
                return
            }
            const date = moment(info.date)
            console.log(date)
            const weekday = date.day()
            const hours = date.hour()
            const minutes = date.minutes()



            console.log("wday: " + weekday)
            if (weekday >= 1 && weekday <= 5) {
                if (hours < 13 || hours >= 21) {
                    console.log("outside buisness hours")
                    $('#alert').html(`
                <div class="mt-4 alert alert-danger alert-dismissible fade show" role="alert">
  Dieser Zeitpunkt ist nicht buchbar, er liegt außerhalb der Öffnungszeiten.
  <button type="button" class="close" data-dismiss="alert" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
</div>`)
                    return
                }

            } else if (weekday == 6 || weekday == 0) {
                if (hours < 10 || hours >= 21) {
                    console.log("outside buisness hours")
                    $('#alert').html(`
                <div class="mt-4 alert alert-danger alert-dismissible fade show" role="alert">
  Dieser Zeitpunkt ist nicht buchbar, er liegt außerhalb der Öffnungszeiten.
  <button type="button" class="close" data-dismiss="alert" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
</div>`)
                    return
                }
            }

            console.log('clicked ' + info.dateStr + ' on resource ' + info.resource.id);

            const hour = 60
            const buffer = 30

            var applicableEvents = events.filter(event => {
                if (event.resourceId != info.resource.id) {
                    return false;
                }

                if (event.rendering == "background") {
                    return false;
                }

                const maxStart = subMinutes(event.start, hour * 3 + buffer)
                const maxEnd = addMinutes(event.end, buffer)

                return maxStart < info.date && maxEnd > info.date

            })

            let overlap = applicableEvents.some(event => {
                const endBuffer = addMinutes(event.end, buffer)
                const startBuffer = subMinutes(event.start, buffer + hour)

                return startBuffer < info.date && endBuffer > info.date
            })

            if (overlap) {

                $('#alert').html(`
                <div class="mt-4 alert alert-danger alert-dismissible fade show" role="alert">
  Dieser Zeitpunkt ist nicht buchbar, er liegt zu nah an einem anderen Event.
  <button type="button" class="close" data-dismiss="alert" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
</div>`)

                return
            }

            let twoHourOverlap = applicableEvents.some(event => {
                const endBuffer = addMinutes(event.end, buffer)
                const startHourBuff = subMinutes(event.start, buffer + 2 * hour)

                return startHourBuff < info.date && endBuffer > info.date
            })

            let threeHourOverlap = applicableEvents.some(event => {
                const endBuffer = addMinutes(event.end, buffer)
                const startHourBuff = subMinutes(event.start, buffer + 3 * hour)

                return startHourBuff < info.date && endBuffer > info.date
            })

            if (hours >= 18) {
                threeHourOverlap = true
            }
            if (hours >= 19) {
                twoHourOverlap = true
            }
            if (hours >= 20) {
                overlap = true
                $('#alert').html(`
                <div class="mt-4 alert alert-danger alert-dismissible fade show" role="alert">
  Dieser Zeitpunkt ist nicht buchbar, er liegt zu nah am Ende der Geschäftszeiten.
  <button type="button" class="close" data-dismiss="alert" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
</div>`)
                return
            }

            var possHours = [1]
            if (!twoHourOverlap) {
                possHours.push(2)
            }
            if (!threeHourOverlap) {
                possHours.push(3)
            }

            window.open('https://sve-hamburg.de/sveevents/?event=11&datum=' + info.dateStr + '&sportstaette=' + info.resource.id + '&stunden=' + possHours, '_blank');

        },
        selectable: true,
        events: events,
        resources: resources,
        nowIndicator: true
    });

    calendar.render()

    console.log(calcRatio())
    calendar.setOption('aspectRatio', calcRatio());
});

function subMinutes(date, minutes) {
    return new Date(date.getTime() - minutes * 60000);
}

function addMinutes(date, minutes) {
    return new Date(date.getTime() + minutes * 60000);
}